export default {
  presenter: 'vician',
  title: 'Linux na desktopu pro Běžně Frustrované Uživatele',
  subtitle: 'začátečníci',
  text: `
GNU/Linux je v CZ.NIC na 90 % osobních počítačů. V přednášce zmíním s jakými problémy jsme se
potýkali a co uživatelům při přechodu z jiného OS nejvíce vadilo. Představím přehled uživatelských
rozhraní, které jsme uživatelům nabízeli, a jak jsme celý proces instalace a používání
zautomatizovali pomocí FAI a Ansiblu.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/vician-linux.js